const instagramData = [
  {
    id: 1,
    imageUrl: "https://i.imgur.com/SiUbkBo.jpg",
  },
  {
    id: 2,
    imageUrl: "https://i.imgur.com/cEHUYaz.jpg",
  },
  {
    id: 3,
    imageUrl: "https://i.imgur.com/8SLUciR.jpg",
  },
  {
    id: 4,
    imageUrl: "https://i.imgur.com/E7eUwJq.jpg",
  },
  {
    id: 5,
    imageUrl: "https://i.imgur.com/w9h4sXX.jpg",
  },
  {
    id: 6,
    imageUrl: "https://i.imgur.com/4NpWgo3.jpg",
  },
  {
    id: 7,
    imageUrl: "https://i.imgur.com/yia131q.jpg",
  },
  {
    id: 8,
    imageUrl: "https://i.imgur.com/Of5NjVi.jpg",
  },
  {
    id: 9,
    imageUrl: "https://i.imgur.com/oPSXjzj.jpg",
  },
  {
    id: 10,
    imageUrl: "https://i.imgur.com/qrwTZVi.jpg",
  },
  {
    id: 11,
    imageUrl: "https://i.imgur.com/qhXlUb2.jpg",
  },
  {
    id: 12,
    imageUrl: "https://i.imgur.com/M57XiNf.jpg",
  },
  {
    id: 13,
    imageUrl: "https://i.imgur.com/zhL0J78.jpg",
  },
];

export default instagramData;
